export const humanFriendlyNumber = (value: number | string): string => {
  const numericValue = typeof value === "string" ? Number(value) : value;

  if (
    numericValue === undefined ||
    numericValue === null ||
    isNaN(numericValue)
  ) {
    return "";
  }

  return numericValue.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};
